import React, { useState } from "react";
import { Form, Row, Col, Select, DatePicker, Button, Space, Spin } from "antd";
import { FilterOutlined, ClearOutlined } from "@ant-design/icons";

const { Option } = Select;
const { RangePicker } = DatePicker;

const OrderFilters = ({ form, customers, loadingCustomers, onFinish, onReset }) => {
  const [searchCustomer, setSearchCustomer] = useState("");

  const handleCustomerSearch = (value) => {
    setSearchCustomer(value);
  };

  const statusOptions = [
    { value: "NEW", label: "Yeni" },
    { value: "IN_PROGRESS", label: "Devam Ediyor" },
    { value: "COMPLETED", label: "Tamamlandı" },
    { value: "CANCELLED", label: "İptal Edildi" },
    { value: "FAILED", label: "Başarısız" },
  ];

  const handleFinish = (values) => {
    const { dateRange, ...rest } = values;

    const formattedValues = {
      ...rest,
      dateRange: dateRange
        ? [
            dateRange[0].format("YYYY-MM-DD") + "T00:00:00",
            dateRange[1].format("YYYY-MM-DD") + "T23:59:59",
          ]
        : null,
    };

    onFinish(formattedValues);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      initialValues={{ status: null, customerIds: [], dateRange: null }}
    >
      <Row gutter={16}>
        <Col xs={24} sm={8} md={6}>
          <Form.Item label="Sipariş Durumu" name="status">
            <Select placeholder="Duruma göre filtrele" allowClear>
              {statusOptions.map((option) => (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={6}>
          <Form.Item label="Müşteriler" name="customerIds">
            <Select
              mode="multiple"
              showSearch
              placeholder="Müşteri seçin"
              allowClear
              loading={loadingCustomers}
              onSearch={handleCustomerSearch}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              notFoundContent={loadingCustomers ? <Spin size="small" /> : "Müşteri bulunamadı"}
              style={{ width: "100%" }}
            >
              {customers
                .filter(
                  (customer) =>
                    !searchCustomer ||
                    customer.name.toLowerCase().includes(searchCustomer.toLowerCase())
                )
                .map((customer) => (
                  <Option key={customer.id} value={customer.id}>
                    {customer.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={8}>
          <Form.Item label="Sipariş Tarihi" name="dateRange">
            <RangePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
          </Form.Item>
        </Col>
        <Col xs={24} md={4} style={{ display: "flex", alignItems: "flex-end" }}>
          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" icon={<FilterOutlined />}>
                Filtrele
              </Button>
              <Button onClick={onReset} icon={<ClearOutlined />}>
                Sıfırla
              </Button>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default OrderFilters;
